import StandardOrder from './StandardOrder';

export default StandardOrder;
